import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const registrationsSchema: CollectionCreateSchema = {
  name: CollectionName.Registrations,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      infix: true,
    },
    {
      name: "registration_name", //identifier
      type: "string",
      facet: true,
      infix: true,
      optional: true,
      sort: true,
    },
    {
      name: "registration_type", //registration_type_id
      type: "int32",
      optional: true,
      infix: true,
    },
    {
      name: "registration_type_code",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "status",
      type: "string",
      optional: true,
      infix: true,
    },
    {
      name: "effective_date",
      type: "int64",
      optional: true,
      infix: true,
    },
    {
      name: "nzbn",
      type: "string",
      optional: true,
      infix: true,
      facet: true,
    },
    {
      name: "expiry_date",
      type: "int64",
      optional: true,
      infix: true,
    },
    {
      name: "organisation_name", //business_name
      type: "string",
      optional: true,
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "address",
      type: "object",
      optional: true,
      infix: true,
      fields: [
        {
          name: "physical_address",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_city",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_state",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_country_code",
          type: "string",
          infix: true,
          optional: true,
        },
        {
          name: "physical_city_postcode",
          type: "string",
          infix: true,
          optional: true,
        },
      ],
    },
    {
      name: "physical_address",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "physical_city",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "physical_state",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "physical_country_code",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "physical_city_postcode",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "type_code",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "accessible_by",
      type: "string[]",
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
